import type { TFunction } from 'i18next';

const PROBLEMS = ['TYPE_MISSING', 'VENDOR_MISSING', 'ATTR_MISSING', 'EMPTY', 'NOT_ALLOCATED'];

/** Why the rule wrote no style number, in words: "the product has no type". */
export function skuProblemWords(t: TFunction, problem: string): string {
  const key = PROBLEMS.includes(problem) ? problem : 'other';
  return t(`products:sku.problem.${key}`);
}

const IN_USE = ['order_line', 'cart_line', 'inventory_movement', 'inventory_reservation'];

/**
 * What refers to a variant's SKU, in words: "ordered, stocked". A store listing alone is not a
 * reason the backend reports, so it is dropped; anything unknown reads "in use".
 */
export function skuInUseWords(t: TFunction, reasons: readonly string[]): string {
  const words = new Set<string>();
  for (const reason of reasons) {
    if (reason === 'store_variant') continue;
    words.add(t(`products:sku.inUse.${IN_USE.includes(reason) ? reason : 'other'}`));
  }
  if (words.size === 0) words.add(t('products:sku.inUse.other'));
  return [...words].join(', ');
}
